import { validate } from 'email-validator';
import { useEffect, useState } from 'react';

export const useHandleEmailInputChange = (value?: string, onChange?: (e: string) => void) => {
  const [email, setEmail] = useState<string>();
  const [valid, setValid] = useState<boolean>(true);

  useEffect(() => {
    if (!!value && valid) {
      setEmail(value);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);

  const handleChangeEvent = (newValue?: string) => {
    const isValid = !!newValue && validate(newValue);

    setValid(isValid);
    setEmail(newValue);
    onChange?.(isValid ? newValue : '');
  };

  return { email, valid, handleChangeEvent };
};
